import React from 'react';
import i18n from 'i18next';

// types
import { Widget } from '@sprinklr/stories/widget/Widget';
import { Theme } from 'models/Theme/Theme';

// helpers
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import { headerTunables, opacityTunables } from 'components/Sidebar/RenderTunables/SharedTunables';
import {
    gridTunables,
    legendTunables,
    metaInfoTunables,
    xAxisTunables,
    yAxisTunables,
} from 'components/Sidebar/RenderTunables/HyperspaceSharedTunables';
import { widgetHasDim } from 'utils/Widget/WidgetUtils';

export const HyperSpaceStackedColumnChartWidgetTunables = (
    widget: Widget,
    mergedTheme: Theme
): TunablesCollapse[] => {
    const isTimeDim: boolean = widgetHasDim(widget, [
        'SN_CREATED_TIME',
        'measurementTime',
        'CREATED_DATE',
        'date',
    ]);
    return [
        {
            props: {
                label: i18n.t('Stacked Column Chart'),
                startOpen: true,
            } as CollapseProps,
            children: [...headerTunables(widget), opacityTunables(widget), gridTunables(widget)],
        },
        metaInfoTunables({ widget, color: true, image: false }),
        xAxisTunables({ widget, ticks: true, mergedTheme, format: isTimeDim }),
        yAxisTunables({ widget, ticks: true, mergedTheme, axisIsDim: false }),
        legendTunables(widget, { metric: false }),
    ];
};
